module.exports = __webpack_public_path__ + "static/media/ic_admin.a5d641c0.svg";